<template>
  <div>
    <v-row class="px-5 mt-5" no-gutters> Datatable </v-row>
    <v-row class="pa-3 mx-2" no-gutters>
        <a-data-table
            v-model="selectedFiles"
            :headers="headers"
            :items="documents"
            class="elevation-1"
            show-select
            item-key="id"
            hide-default-footer
            :no-data-text="$t('noData')"
            :loading-text="$t('LoaderText')"
            mobile-breakpoint="0"
            disable-pagination
        >
            <template v-slot:[`header.name`]="{ header }">
                <span class="header-text"> {{ header.text }}</span>
            </template>
            <template v-slot:[`header.date`]="{ header }">
                <span class="header-text"> {{ header.text }} </span>
            </template>

            <template v-slot:[`item.name`]="{ item }">
                <span class="primary--text" v-if="item.type == 'directory'">
                    <v-icon class="mr-3"> mdi-folder </v-icon>{{ item.name }}
                </span>
                <span class="primary--text" v-else>
                    <v-icon class="mr-3">mdi-file-document</v-icon> {{ item.name }} <v-icon color="#E69900">mdi-new-box</v-icon></span>
            </template>
            <template v-slot:[`item.date`]="{ item }">
                <span class="secondary-darken5--text">{{ item.date }}</span>
            </template>
            <template v-slot:body.append>
                <tr style="height: 56px !important; padding: 12px;">
                    <td colspan='3' > <file-input /> </td>
                </tr>
            </template>
            <!-- <template v-slot:footer>
                <div style="margin: 12px"> <file-input class="m-5"/> </div>
            </template> -->
        </a-data-table>
    </v-row>
  </div>
</template>

<script>
import ADataTable from './ADataTable.vue';
import FileInput from './FileInput.vue';
export default {
  components: { ADataTable, FileInput },
  name: "DataTableSample",
  data() {
    return {
        selectedFiles: [1],
        headers: [
            {
                text: "Title",
                value: "name",
                align: "left",
                class: "header"
            },
            {
                text: "Upload Time",
                value: "date",
                align: "left",
                class: "header"
            },
        ],
        documents: [
            {
                type: '',
                id: '1',
                name: 'demo_test_search.txt',
                date: 'Monday, 1/2/2023 at 3:00 PM',
            },
            {
                type: '',
                id: '2',
                name: 'Screenshot 2022-11-08 131140.png',
                date: 'Tuesday, 1/1/2022 at 3:40 PM',
            },
            {
                type: '',
                id: '3',
                name: 'pkpadmin,+1008-4741-1-CE.pdf',
                date: 'Wednesday, 1/2/2023 at 7:20 PM',
            },
            {
                type: 'directory',
                id: '4',
                name: 'ROot',
                date: '',
            }
        ]
    };
  },
};
</script>

<style scoped>
.card-div {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
</style>